import { Component, OnInit } from '@angular/core';
import { PartnersService } from 'src/app/private/admin/services/partners.service';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss']
})
export class PartnersComponent implements OnInit {

  partnersList

  constructor(private partnersService: PartnersService) { }

  ngOnInit(): void {
    this.partnersService.getPartnersUser().then((res:any)=> {
      this.partnersList=res.partners
      console.log(this.partnersList)
    })
    
  }

}
